import React, { useState } from "react";
import { auth } from "../../firebase/firebaseConfig";
import { signInWithEmailAndPassword, } from "firebase/auth";

import { useNavigate } from "react-router-dom";



export const Login: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    //below is the structures/state variable for player search
    

    const navigate = useNavigate();

    //reaches out to firebase to submit a login
    const handleLogin = async (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault(); // Prevent the default form submission behavior
        try {
            await signInWithEmailAndPassword(auth, email, password);
            //route to a homepage that shows users current status
            navigate("/dashboard")
           
        } catch (error) {
            console.error(error);
            alert("Login failed. Check your credentials.");
        }
    };


    return (
        <div className="home-page">

            <form className="login-container" onSubmit={(e) => handleLogin(e)}>
                <h1>Login</h1>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                
                <button type="submit" onClick={(e) => handleLogin(e)}>Login</button>
                <div className="buttons-container">
                    
                    <button type="button" onClick={() => navigate("/signup")}>Sign Up</button>
                    <button type="button" onClick={() => navigate("/forgot-password")}>Forgot Password?</button>
                </div>
            </form>

        </div>
    );
};

require('./styles.scss')
